import React from 'react';
import { Link } from 'react-router-dom';
import { companyInfo, partnerLogos } from '../../data/mockData';
import './Hero.css';

const Hero = () => (
  <section className="hero" data-testid="hero-section">
    <span className="hero-bracket hero-bracket-tr" aria-hidden="true" />
    <span className="hero-bracket hero-bracket-bl" aria-hidden="true" />

    <div className="container hero-inner">
      <div className="hero-heritage" data-testid="hero-heritage">
        <img src={partnerLogos[0].url} alt={partnerLogos[0].name} />
        <span className="hero-heritage-x">×</span>
        <img src={partnerLogos[1].url} alt={partnerLogos[1].name} />
      </div>

      <h1 className="hero-title" data-testid="hero-title">
        Services informatiques sur-mesure, créateurs de valeur pour votre entreprise
      </h1>

      <p className="hero-description" data-testid="hero-description">
        {companyInfo.description}
      </p>

      <img src="/assets/pictos/zigzag.svg" alt="" className="hero-squiggle" aria-hidden="true" />

      <Link to="/contact" className="hero-btn" data-testid="hero-contact-button">
        Nous contacter
      </Link>

      <a href="#expertise" className="hero-scroll" aria-label="Faire défiler" data-testid="hero-scroll-indicator">
        <img src="/assets/pictos/scroll.svg" alt="" aria-hidden="true" />
      </a>
    </div>
  </section>
);

export default Hero;
